'use client';

import { c as _c } from "react/compiler-runtime";
import { ConfigurationStatus } from '@repo/api-gw-sdk';
import { useMemo } from 'react';
import { useIsUnsupportedStatusOffered } from '@/app/(dashboard)/inventory/inventorySettingsContext';

// The order the filter bar offers them in: in-scope values first, ending with the five
// out-of-scope causes, which is the order the status model itself reads in.
const FILTERABLE_CONFIGURATION_STATUSES: ConfigurationStatus[] = [ConfigurationStatus.CONFIGURATION_STATUS_ASSIGNED, ConfigurationStatus.CONFIGURATION_STATUS_UNASSIGNED, ConfigurationStatus.CONFIGURATION_STATUS_INITIAL_CLASSIFICATION, ConfigurationStatus.CONFIGURATION_STATUS_CLASSIFICATION_FAILED, ConfigurationStatus.CONFIGURATION_STATUS_ACCESS_LOST, ConfigurationStatus.CONFIGURATION_STATUS_TERMINATED, ConfigurationStatus.CONFIGURATION_STATUS_DISCONNECTED, ConfigurationStatus.CONFIGURATION_STATUS_EXCLUDED_FROM_BACKUP, ConfigurationStatus.CONFIGURATION_STATUS_LIMIT_EXCEEDED, ConfigurationStatus.CONFIGURATION_STATUS_UNSUPPORTED];

/**
 * The configuration statuses this account can currently filter by. Only `UNSUPPORTED` is
 * gated: filtering by a status the inventory keeps out of view would contradict the scope
 * it is applying, so it is offered once the inventory settings turn unsupported resources
 * on. Nothing here is async, but the shape matches the compliance hook so both read the
 * same way at the call site.
 */
export const useAvailableConfigurationStatuses = () => {
  const $ = _c(4);
  const isUnsupportedOffered = useIsUnsupportedStatusOffered();
  let t0;
  if ($[0] !== isUnsupportedOffered) {
    t0 = FILTERABLE_CONFIGURATION_STATUSES.filter(status => isUnsupportedOffered || status !== ConfigurationStatus.CONFIGURATION_STATUS_UNSUPPORTED);
    $[0] = isUnsupportedOffered;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const statuses = t0;
  let t1;
  if ($[2] !== statuses) {
    t1 = {
      statuses,
      isLoading: false
    };
    $[2] = statuses;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
};